import type { MeasurementType } from "../types.ts";

export type UnitSystem = "metric" | "imperial";

const M_TO_FT = 3.28084;
const M2_TO_FT2 = 10.7639;

const currentSystem: UnitSystem =
  import.meta.env.VITE_UNITS === "metric" ? "metric" : "imperial";

export function getUnitSystem(): UnitSystem {
  return currentSystem;
}

export function isImperial(): boolean {
  return currentSystem === "imperial";
}

/** Convert a raw metric value + return the display unit string. */
export function convertValue(
  metricValue: number,
  type: MeasurementType,
): { value: number; unit: string } {
  if (currentSystem === "metric") {
    switch (type) {
      case "distance":
      case "height":
        return { value: metricValue, unit: "m" };
      case "area":
        return { value: metricValue, unit: "m²" };
      case "point":
        return { value: 0, unit: "" };
    }
  }

  switch (type) {
    case "distance":
    case "height":
      return { value: metricValue * M_TO_FT, unit: "ft" };
    case "area":
      return { value: metricValue * M2_TO_FT2, unit: "ft²" };
    case "point":
      return { value: 0, unit: "" };
  }
}
